export default "__VITE_ASSET__do13HSan__";